import app from 'flarum/common/app';
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
import Select from 'flarum/common/components/Select';
import Stream from 'flarum/common/utils/Stream';
import labelText from '../../common/utils/labelText';
export default class EditListingModal extends FormModal {
  oninit(vnode) {
    super.oninit(vnode);
    const discussion = this.attrs.discussion;
    this.label = Stream(discussion.listingLabel() || '');
    this.price = Stream(discussion.listingPrice() != null ? String(discussion.listingPrice()) : '');
    this.priceMax = Stream(discussion.listingPriceMax() != null ? String(discussion.listingPriceMax()) : '');
    this.currency = Stream(discussion.listingCurrency() || app.forum.attribute('classifiedsDefaultCurrency') || 'USD');
    this.location = Stream(discussion.listingLocation() || '');
  }
  className() {
    return 'EditListingModal Modal--small';
  }
  title() {
    return app.translator.trans('flarum-classifieds.forum.edit_listing.title');
  }
  content() {
    const labels = (app.forum.attribute('classifiedsAllowedLabels') || 'iso,wtb,wts,trade').split(',').map(l => l.trim()).filter(Boolean);
    const labelOptions = {
      '': app.translator.trans('flarum-classifieds.forum.composer.label_placeholder', {}, true)
    };
    labels.forEach(l => {
      labelOptions[l] = labelText(l);
    });
    const allowRange = !!app.forum.attribute('classifiedsAllowPriceRange');
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "Form"
    }, m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('flarum-classifieds.forum.composer.label_label')), m(Select, {
      options: labelOptions,
      value: this.label(),
      onchange: this.label
    })), m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('flarum-classifieds.forum.composer.price_label')), m("input", {
      className: "FormControl",
      type: "number",
      step: "0.01",
      min: "0",
      bidi: this.price
    })), allowRange && m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('flarum-classifieds.forum.composer.price_max_label')), m("input", {
      className: "FormControl",
      type: "number",
      step: "0.01",
      min: "0",
      bidi: this.priceMax
    })), m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('flarum-classifieds.forum.composer.currency_label')), m("input", {
      className: "FormControl",
      type: "text",
      maxlength: "8",
      bidi: this.currency
    })), m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('flarum-classifieds.forum.composer.location_label')), m("input", {
      className: "FormControl",
      type: "text",
      maxlength: "255",
      bidi: this.location
    })), m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--primary",
      type: "submit",
      loading: this.loading
    }, app.translator.trans('flarum-classifieds.forum.edit_listing.save_button')))));
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    const discussion = this.attrs.discussion;
    discussion.save({
      listingLabel: this.label() || null,
      listingPrice: this.price() === '' ? null : this.price(),
      listingPriceMax: this.priceMax() === '' ? null : this.priceMax(),
      listingCurrency: this.currency() || null,
      listingLocation: this.location() || null
    }).then(() => {
      this.loading = false;
      this.hide();
      m.redraw();
    }, err => {
      this.loading = false;
      this.loaded();
      throw err;
    });
  }
}
flarum.reg.add('ramon-classifieds', 'forum/components/EditListingModal', EditListingModal);